import React from 'react';
import styled from 'styled-components';
import { useGlobalState } from '../stateProvider/StateProvider';
import { SiteHasFeature } from '../RequireFeature';

const Wrapper = styled.div`
    all: inherit;
    padding: ${({ index, padding = 2 }) => !index ? `0 0 ${padding}em 0` : `${padding}em 0`};
    border-bottom: ${({ lineBreak }) => lineBreak ? 1 : 0}px solid ${({ theme }) => theme.secondary}40;
`;

const PageBreak = ({ children, requiredFeatures, ...props }) => {
    const { state: { features } } = useGlobalState();

    // Parent gate
    if (!SiteHasFeature(features, requiredFeatures ?? [])) {
        return null;
    }

    if (children instanceof Array) {
        const filtered = children.filter(
            e => e && SiteHasFeature(features, e.props?.requiredFeatures ?? [])
        );

        return filtered.map((e, i) => (
            <Wrapper
                key={`${i}-pageBreak`}
                lineBreak={i !== filtered.length - 1}
                index={i}
                {...props}
            >
                {e}
            </Wrapper>
        ));
    }

    return children;
};

export default PageBreak;
